import { getApi } from './server'

const API_SERVICE_NAME = 'api'

/** Returns the URL for a service running alongside the configured API service. */
export function getClusterServiceUrl(serviceName: string) {
  return getApi().replace(API_SERVICE_NAME, serviceName)
}
